module.exports = __webpack_public_path__ + "static/media/bike1-.b4c1cb3c.png";